import { render, staticRenderFns } from "./Streaks.vue?vue&type=template&id=226d0116"
import script from "./Streaks.vue?vue&type=script&lang=js"
export * from "./Streaks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports